module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-wrap",
    class: {
      'component-padded': _vm.base.padded, 'active': _vm.active
    }
  }, [_c('div', {
    staticClass: "current-active"
  }), _vm._v(" "), _c('div', {
    staticClass: "content",
    class: {
      'bold': _vm.config.bold, 'italic': _vm.config.italic
    },
    style: ({
      color: _vm.config.color,
      fontSize: _vm.config.size + 'px',
      textAlign: _vm.config.align
    })
  }, [_vm._v("\n    " + _vm._s(_vm.data[0].content) + "\n  ")])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-583eb5e2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-583eb5e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/heading.vue
// module id = 2735
// module chunks = 0